import React from 'react';
import Footer from '../components/Footer';

export default (props: any) => <Footer {...props} />;
